import i18n from '../plugins/i18n';
import vuetify from '../plugins/vuetify';

const STORAGE_KEY = 'migly_locale';
const supportedLocales = ['pt-br', 'en'];

function detectBrowserLocale() {
  const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
  return nav.startsWith('pt') ? 'pt-br' : 'en';
}

function applyLocale(locale) {
  i18n.locale = locale;
  vuetify.framework.lang.current = locale === 'pt-br' ? 'pt' : 'en';
  document.documentElement.setAttribute('lang', locale === 'pt-br' ? 'pt-BR' : 'en');
}

function initLocale() {
  const stored = localStorage.getItem(STORAGE_KEY);
  const locale = supportedLocales.includes(stored) ? stored : detectBrowserLocale();
  applyLocale(locale);
}

function setLocale(locale) {
  if (!supportedLocales.includes(locale)) return;
  applyLocale(locale);
  localStorage.setItem(STORAGE_KEY, locale);
}

function getLocale() {
  return i18n.locale;
}

export default {
  supportedLocales,
  initLocale,
  setLocale,
  getLocale,
};
